import { msg } from '../../i18n/msg';

/**
 * Шаги туториала (подсказки «рукой» после первого входа).
 *
 * Чтобы добавить/убрать/переставить шаг — правим только этот массив:
 *   1. на нужный элемент вешаем атрибут data-tutorial="<target>";
 *   2. добавляем сюда объект шага.
 *
 * Поля шага:
 *   id          — уникальный ключ; пройденные шаги сохраняются по id, поэтому порядок можно менять
 *   target      — значение data-tutorial у элемента, на который указывает рука
 *   route       — (необязательно) шаг показывается только на этом pathname
 *   completeOn  — 'click' (тап по подсвеченному элементу) или { event: '<имя>' } —
 *                 шаг закрывается, когда код игры вызовет dispatch(tutorialEvent('<имя>'))
 *   text        — реплика робота msg(ключ, английский дефолт); без text показывается только рука
 *   anchor      — (необязательно) точка касания внутри элемента в долях { x, y }, по умолчанию центр
 *                 (у широких кнопок — левая четверть, как в макете)
 *
 * Пока элемента нет на экране (идёт спин, другая страница, открыт попап награды) —
 * оверлей не показывается и ничего не блокирует, шаг просто ждёт.
 */
export const TUTORIAL_STEPS = [
  {
    id: 'spin',
    target: 'spin-button',
    route: '/lucky-spin',
    completeOn: { event: 'spin' },
    text: msg('tutorial.step.spin', "Tap it. Don't keep me waiting."),
  },
  {
    id: 'progress-claim',
    target: 'progress-claim',
    route: '/lucky-spin',
    completeOn: 'click',
    text: msg('tutorial.step.progress_claim', 'The bar is full. Grab your first reward.'),
  },
  {
    id: 'menu-tasks',
    target: 'menu-tasks',
    completeOn: 'click',
    text: msg('tutorial.step.menu_tasks', 'Tasks pay out coins and chests. Check them often.'),
  },
  {
    id: 'menu-inventory',
    target: 'menu-inventory',
    completeOn: 'click',
    text: msg('tutorial.step.menu_inventory', 'Your hero and every module you win live here.'),
  },
];

export const TUTORIAL_SPEAKER = 'ROBO-DEALER';

export const TUTORIAL_SKIP = msg('tutorial.skip', 'Skip');
